import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  EstablishmentInfrastructureData,
  EstablishmentInfrastructureResponse,
} from '@/common/types/establishmentInfrastructure'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useEstablishmentInfrastructure: (
  id: string,
) => UseQueryResult<EstablishmentInfrastructureData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EstablishmentInfrastructureResponse, unknown, EstablishmentInfrastructureData>({
    queryKey: ['establishmentInfrastructure', id],
    queryFn: () => privateAxios.get(`/maintenance/establishment_infrastructures/${id}`),
    select: (data) => data?.data?.data,
  })
}
